/* This file was automatically generated on 1562128164 */

/* eslint-disable global-require */
module.exports = {
  arithmetic: require('./arithmetic.js'),
  assignment: require('./assignment.js'),
  bit: require('./bit.js'),
  comparison: require('./comparison.js'),
  exponentiation: require('./exponentiation.js'),
  logical: require('./logical.js'),
  shift: require('./shift.js')
};